import { Pagination } from 'antd';
import { BtlCasesSearchTable } from './BtlCasesSearchTable';
import { useDebounce } from '@hooks/useDebounce';
import { useBrokerCasesSearch } from '@queries/brokerCases/useBrokerCasesSearch';
import { useEffect, useMemo, useState } from 'react';

const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];
const DEFAULT_PAGE_SIZE = 10;

interface BtlCasesSearchResultsProps {
  searchInputValue: string;
}

export function BtlCasesSearchResults({ searchInputValue }: BtlCasesSearchResultsProps) {
  const debouncedSearch = useDebounce(searchInputValue, 300);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  const searchParams = useMemo(
    () => ({
      q: debouncedSearch.trim() || undefined,
      applicationType: 'BUY_TO_LET' as const,
      page,
      limit: pageSize,
    }),
    [debouncedSearch, page, pageSize],
  );

  const { data, isLoading, isFetching } = useBrokerCasesSearch(searchParams);

  return (
    <div>
      <BtlCasesSearchTable cases={data?.data} isLoading={isLoading || isFetching} />
      <div className={'flex justify-end py-2'}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={data?.pagination.totalCount ?? 0}
          showSizeChanger
          showLessItems={false}
          responsive={false}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
          locale={{ items_per_page: '' }}
          onChange={(nextPage, nextPageSize) => {
            setPage(nextPage);
            setPageSize(nextPageSize);
          }}
        />
      </div>
    </div>
  );
}
